export const phoneNum = {
  label: "(833) 592-2456",
  value: "+18335922456",
};
